/* EMA brakes: brake demo ([data-brake-demo]) + product buy panel ([data-bk-buy]).
   Used by sections/brake-shop.liquid and sections/brake-collection.liquid. */
(function () {
  'use strict';
  if (window.__emaBrakeShop) return;
  window.__emaBrakeShop = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- brake demo ---------------- */
  function initDemo(root) {
    var spins = root.querySelectorAll('[data-bkd-spin]');
    var pulses = root.querySelectorAll('[data-bkd-pulse]');
    var heat = root.querySelector('[data-bkd-heat]');
    var padL = root.querySelector('[data-bkd-pad="l"]');
    var padR = root.querySelector('[data-bkd-pad="r"]');
    var hold = root.querySelector('[data-bkd-hold]');
    var fill = root.querySelector('[data-bkd-fill]');
    var pct = root.querySelector('[data-bkd-pct]');
    var statusText = root.querySelector('[data-bkd-status-text]');
    var rotorLabel = root.querySelector('[data-bkd-rotor-label]');
    var opts = root.querySelectorAll('[data-bkd-mode]');

    var MAX = reduceMotion ? 220 : 620;          // deg/s
    var s = { a: 0, v: MAX, p: 0, b: false, mode: root.getAttribute('data-mode') || 'ub' };
    var last = null, raf = null, visible = true, lastState = '', lastPct = -1;

    function setMode(m) {
      s.mode = m;
      root.setAttribute('data-mode', m);
      s.v = MAX;
      for (var i = 0; i < opts.length; i++) opts[i].setAttribute('aria-checked', opts[i].getAttribute('data-bkd-mode') === m ? 'true' : 'false');
      if (rotorLabel) rotorLabel.textContent = (m === 'stock' ? root.getAttribute('data-stock-label') : root.getAttribute('data-ub-label')).toUpperCase();
    }
    for (var i = 0; i < opts.length; i++) {
      opts[i].addEventListener('click', function (e) { setMode(e.currentTarget.getAttribute('data-bkd-mode')); });
    }

    function press(e) {
      if (e && e.pointerId !== undefined && hold.setPointerCapture) { try { hold.setPointerCapture(e.pointerId); } catch (err) {} }
      if (e && e.cancelable) e.preventDefault();
      s.b = true; root.classList.add('is-braking'); hold.setAttribute('aria-pressed', 'true');
      start();
    }
    function release() { s.b = false; root.classList.remove('is-braking'); hold.setAttribute('aria-pressed', 'false'); }
    hold.addEventListener('pointerdown', press);
    hold.addEventListener('pointerup', release);
    hold.addEventListener('pointercancel', release);
    hold.addEventListener('lostpointercapture', release);
    hold.addEventListener('contextmenu', function (e) { e.preventDefault(); });
    hold.addEventListener('keydown', function (e) { if ((e.key === ' ' || e.key === 'Enter') && !e.repeat) { e.preventDefault(); press(); } });
    hold.addEventListener('keyup', function (e) { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); release(); } });
    hold.addEventListener('blur', release);

    function render() {
      var rot = 'rotate(' + s.a.toFixed(2) + ' 200 250)';
      for (var i = 0; i < spins.length; i++) spins[i].setAttribute('transform', rot);
      var off = (100 - s.p * 100).toFixed(1);
      for (var j = 0; j < pulses.length; j++) pulses[j].setAttribute('stroke-dashoffset', off);
      var clamp = s.p > 0.85;
      padL.setAttribute('x', (268 + s.p * 5).toFixed(1));
      padR.setAttribute('x', (290 - s.p * 5).toFixed(1));
      padL.setAttribute('fill', clamp ? '#ec4899' : '#6b7280');
      padR.setAttribute('fill', clamp ? '#ec4899' : '#6b7280');
      var frac = s.v / MAX;
      heat.setAttribute('opacity', s.b ? (Math.min(1, s.p) * Math.max(0.25, frac)).toFixed(2) : '0');
      fill.style.transform = 'scaleX(' + frac.toFixed(3) + ')';
      var p = Math.round(frac * 100);
      if (p !== lastPct) { pct.textContent = p + '%'; lastPct = p; }
      var st = s.b ? (s.v < 1 ? 'stopped' : 'braking') : (frac < 0.98 ? 'spinup' : 'spin');
      if (st !== lastState) {
        lastState = st;
        root.setAttribute('data-state', st);
        statusText.textContent = st === 'stopped' ? 'Stopped' : st === 'braking' ? 'Braking' : st === 'spinup' ? 'Spinning back up' : 'Spinning — hold to brake';
      }
    }

    function tick(t) {
      raf = null;
      if (last === null) last = t;
      var dt = Math.min(0.05, (t - last) / 1000);
      last = t;
      if (s.b) {
        s.p = Math.min(1, s.p + dt * 5);
        var decel = s.mode === 'stock' ? 480 : 1300;
        if (s.p > 0.85) s.v = Math.max(0, s.v - decel * dt);
      } else {
        s.p = Math.max(0, s.p - dt * 3.5);
        s.v = Math.min(MAX, s.v + 300 * dt);
      }
      s.a = (s.a + s.v * dt) % 360;
      render();
      if (visible || s.b) raf = requestAnimationFrame(tick); else last = null;
    }
    function start() { if (!raf) { last = null; raf = requestAnimationFrame(tick); } }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) start();
      }, { rootMargin: '100px' }).observe(root);
    }
    setMode(s.mode);
    render();
    start();
  }

  /* ---------------- buy panel ---------------- */
  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  function initBuy(root) {
    var bikes = root.querySelectorAll('[data-bk-bike]');
    var fits = root.querySelectorAll('[data-bk-fit]');
    var fitName = root.querySelector('[data-bk-fit-name]');
    var fitVersion = root.querySelector('[data-bk-fit-version]');
    var btn = root.querySelector('[data-bk-add]');
    var err = root.querySelector('[data-bk-error]');
    var totalEl = root.querySelector('[data-bk-total]');
    var priceEl = root.querySelector('[data-bk-price]');
    var addon = root.querySelector('[data-bk-addon]');
    var addonToggle = root.querySelector('[data-bk-addon-toggle]');
    var addonOpts = root.querySelectorAll('[data-bk-addon-variant]');
    var mainImg = root.querySelector('.bk__main-img');
    var thumbs = root.querySelectorAll('[data-bk-thumb]');

    var basePrice = 0;
    if (priceEl) basePrice = Math.round(parseFloat(priceEl.textContent.replace(/[^0-9.]/g, '')) * 100) || 0;
    var state = { variant: btn.getAttribute('data-default-variant') || '', other: false, soldout: false, addon: false, addonVariant: '', addonPrice: 0 };

    /* gallery */
    for (var t = 0; t < thumbs.length; t++) {
      thumbs[t].addEventListener('click', function (e) {
        var b = e.currentTarget;
        for (var k = 0; k < thumbs.length; k++) thumbs[k].setAttribute('aria-pressed', thumbs[k] === b ? 'true' : 'false');
        if (!mainImg) return;
        mainImg.classList.add('is-swap');
        setTimeout(function () {
          mainImg.removeAttribute('srcset');
          mainImg.src = b.getAttribute('data-bk-thumb');
          mainImg.classList.remove('is-swap');
        }, 160);
      });
    }

    function showFit(which) {
      for (var i = 0; i < fits.length; i++) fits[i].hidden = fits[i].getAttribute('data-bk-fit') !== which;
    }

    function update() {
      var total = basePrice + (state.addon ? state.addonPrice : 0);
      totalEl.textContent = money(total);
      btn.classList.remove('is-other');
      if (state.other) {
        btn.setAttribute('aria-disabled', 'false');
        btn.classList.add('is-other');
        btn.textContent = btn.getAttribute('data-label-other');
      } else if (!state.variant || state.soldout) {
        btn.setAttribute('aria-disabled', 'true');
        btn.textContent = state.soldout ? 'Sold out' : btn.getAttribute('data-label-pick');
      } else {
        btn.setAttribute('aria-disabled', 'false');
        btn.textContent = state.addon ? btn.getAttribute('data-label-build') : btn.getAttribute('data-label-add');
      }
    }

    function pickBike(el) {
      for (var i = 0; i < bikes.length; i++) bikes[i].setAttribute('aria-checked', bikes[i] === el ? 'true' : 'false');
      state.other = el.getAttribute('data-other') === 'true';
      state.variant = state.other ? '' : el.getAttribute('data-variant');
      state.soldout = !state.other && el.getAttribute('data-available') !== 'true';
      if (state.other) showFit('other');
      else if (state.soldout) showFit('soldout');
      else {
        if (fitName) fitName.textContent = el.getAttribute('data-name');
        if (fitVersion) fitVersion.textContent = el.getAttribute('data-version');
        showFit('yes');
      }
      err.hidden = true;
      update();
    }
    for (var b = 0; b < bikes.length; b++) bikes[b].addEventListener('click', function (e) { pickBike(e.currentTarget); });

    /* ?bike=<model> from the collection page pre-selects a tile */
    try {
      var want = new URLSearchParams(window.location.search).get('bike');
      if (want) for (var q = 0; q < bikes.length; q++) if (bikes[q].getAttribute('data-key') === want) { pickBike(bikes[q]); break; }
    } catch (e) {}

    /* titanium add-on */
    function pickAddon(el) {
      for (var i = 0; i < addonOpts.length; i++) addonOpts[i].setAttribute('aria-checked', addonOpts[i] === el ? 'true' : 'false');
      state.addonVariant = el.getAttribute('data-bk-addon-variant');
      state.addonPrice = parseInt(el.getAttribute('data-price'), 10) || 0;
    }
    function setAddon(on) {
      state.addon = on;
      if (addonToggle) { addonToggle.setAttribute('aria-pressed', on ? 'true' : 'false'); addonToggle.textContent = on ? 'Added' : 'Add'; }
      if (addon) addon.classList.toggle('is-on', on);
      update();
    }
    if (addonOpts.length) {
      pickAddon(addonOpts[0]);
      for (var a = 0; a < addonOpts.length; a++) addonOpts[a].addEventListener('click', function (e) { pickAddon(e.currentTarget); setAddon(true); });
    }
    if (addonToggle) addonToggle.addEventListener('click', function () { setAddon(!state.addon); });

    /* add to cart (same flow as the paint shop: Dawn cart drawer/notification if present, else /cart) */
    function goToCart() { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; }
    btn.addEventListener('click', function () {
      if (state.other) { window.location.href = btn.getAttribute('data-contact') || '/pages/contact'; return; }
      if (btn.getAttribute('aria-disabled') === 'true' || btn.classList.contains('is-loading')) {
        if (!state.variant && bikes.length) {
          var group = root.querySelector('.bk__bikes');
          if (group) group.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        }
        return;
      }
      var items = [{ id: parseInt(state.variant, 10), quantity: 1 }];
      if (state.addon && state.addonVariant) items.push({ id: parseInt(state.addonVariant, 10), quantity: 1 });
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var body = { items: items };
      if (cart && cart.getSectionsToRender) {
        body.sections = cart.getSectionsToRender().map(function (x) { return x.id; }).join(',');
        body.sections_url = window.location.pathname;
        if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
      }
      btn.classList.add('is-loading');
      btn.textContent = 'Adding…';
      err.hidden = true;
      fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      }).then(function (res) { return res.json().then(function (json) { return { ok: res.ok, json: json }; }); })
        .then(function (r) {
          btn.classList.remove('is-loading');
          if (!r.ok || r.json.status) {
            err.textContent = (r.json && (r.json.description || r.json.message)) || 'Could not add to cart. Please try again.';
            err.hidden = false;
            update();
            return;
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'brake-shop', productVariantId: items[0].id, cartData: r.json });
          document.dispatchEvent(new CustomEvent('ema:cart:changed'));
          btn.classList.add('is-added');
          btn.textContent = 'Added ✓';
          setTimeout(function () { btn.classList.remove('is-added'); update(); }, 1800);
          if (cart && r.json.sections) { try { cart.renderContents(r.json); } catch (e2) { goToCart(); } }
          else goToCart();
        })
        .catch(function () {
          btn.classList.remove('is-loading');
          err.textContent = 'Could not add to cart. Check your connection and try again.';
          err.hidden = false;
          update();
        });
    });

    update();
  }

  function init() {
    var d = document.querySelectorAll('[data-brake-demo]');
    for (var i = 0; i < d.length; i++) if (!d[i].__bk) { d[i].__bk = 1; initDemo(d[i]); }
    var b = document.querySelectorAll('[data-bk-buy]');
    for (var j = 0; j < b.length; j++) if (!b[j].__bk) { b[j].__bk = 1; initBuy(b[j]); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
